var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _circle3, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaintingBidPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "#FFF3E0",
    stroke: "#F57C00",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20h24v4H18v-4zm0 6h24v2H18v-2zm0 4h24v2H18v-2z",
    fill: "#F57C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15h30v4H15v-4zm0 6h30v2H15v-2zm0 4h30v2H15v-2zm0 4h30v2H15v-2zm0 4h30v2H15v-2zm0 4h30v2H15v-2zm0 4h30v4H15v-4z",
    fill: "#F57C00",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 20,
    r: 8,
    fill: "#4CAF50",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20l2 2 4-4",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 45h16v6H22v-6z",
    fill: "#F57C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45v6M29 45v6M33 45v6",
    stroke: "white",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 35,
    r: 3,
    fill: "#FF9800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33h4v4h-4v-4z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintingBidPlan);
export default __webpack_public_path__ + "static/media/painting-bid-plan.4eef943edc3a544d26551715ff8d3cfd.svg";
export { ForwardRef as ReactComponent };